// ==============================|| OVERRIDES - CHECKBOX ||============================== //

export default function Checkbox() {
  return {
    MuiCheckbox: {
      styleOverrides: {
        root: {
          "&:hover": {
            backgroundColor: 'transparent',
          },
        },
      }
    }
  };
}
